import React from 'react';
import Script from 'react-load-script';

export default function(Component) {
  class StripeHOC extends React.Component {
    state = {
      scriptLoaded: false,
    };

    handleScriptLoad = () => {
      this.setState({ scriptLoaded: true });
    };

    render() {
      const { scriptLoaded } = this.state;
      if (!scriptLoaded) {
        return (
          <Script
            url="https://checkout.stripe.com/checkout.js"
            onLoad={this.handleScriptLoad}
          />
        );
      }

      return <Component {...this.props} />;
    }
  }

  return StripeHOC;
}



// WEBPACK FOOTER //
// ./src/routes/assessment/routes/Booking/StripeHOC.js